/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Message_BuyerInputs */

const en_message_buyer = /** @type {(inputs: Message_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message Buyer`)
};

const es_message_buyer = /** @type {(inputs: Message_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje al Comprador`)
};

const fr_message_buyer = /** @type {(inputs: Message_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter l'acheteur`)
};

const de_message_buyer = /** @type {(inputs: Message_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer kontaktieren`)
};

const id_message_buyer = /** @type {(inputs: Message_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Pembeli`)
};

/** @type {(inputs: Message_BuyerInputs) => LocalizedString} */
const ja_message_buyer = en_message_buyer;

/** @type {(inputs: Message_BuyerInputs) => LocalizedString} */
const zh_message_buyer = en_message_buyer;

/** @type {(inputs: Message_BuyerInputs) => LocalizedString} */
const ar_message_buyer = en_message_buyer;

/** @type {(inputs: Message_BuyerInputs) => LocalizedString} */
const it_message_buyer = en_message_buyer;

/** @type {(inputs: Message_BuyerInputs) => LocalizedString} */
const ru_message_buyer = en_message_buyer;

/** @type {(inputs: Message_BuyerInputs) => LocalizedString} */
const pt_message_buyer = en_message_buyer;

/** @type {(inputs: Message_BuyerInputs) => LocalizedString} */
const ko_message_buyer = en_message_buyer;

/**
* | output |
* | --- |
* | "Message Buyer" |
*
* @param {Message_BuyerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const message_buyer = /** @type {((inputs?: Message_BuyerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Message_BuyerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_message_buyer(inputs)
	if (locale === "es") return es_message_buyer(inputs)
	if (locale === "fr") return fr_message_buyer(inputs)
	if (locale === "de") return de_message_buyer(inputs)
	if (locale === "ja") return ja_message_buyer(inputs)
	if (locale === "zh") return zh_message_buyer(inputs)
	if (locale === "ar") return ar_message_buyer(inputs)
	if (locale === "id") return id_message_buyer(inputs)
	if (locale === "it") return it_message_buyer(inputs)
	if (locale === "ru") return ru_message_buyer(inputs)
	if (locale === "pt") return pt_message_buyer(inputs)
	return ko_message_buyer(inputs)
});